import React from 'react';
import styled from 'styled-components';
import CRMLogo from '../assets/images/somos-crm.png';
import { pmWhite } from '../sharedData/Constants';
import Background from '../assets/images/header-background.png';
import ArrowSeparator from '../assets/images/arrow_separator.png';
import { MobileWidth } from '../sharedData/Constants';
  
const Header = () => {
    return(
        <>
        <StyledView>
            <StyledArrowSeparator src={ArrowSeparator}/>
            <ContentContainer>
                <LogoContainer>
                    <a rel="noreferrer" target="_blank" href='https://www.pmweb.com.br'>
                        <StyledLogo src={CRMLogo} alt="Logo CRM" />    
                    </a>
                </LogoContainer>
                <MainTitle>
                    ESTUDO 2024
                </MainTitle>
                <MainTitleSpot>
                    BLACK FRIDAY.
                </MainTitleSpot>
                <MainText>
                    Faltando pouco para a Black Friday de 2024, <span>as expectativas de consumo estão altas, refletindo o<br/> otimismo do mercado e as novas tendências de comportamento dos consumidores.</span><br/> <br/>

                    As expectativas de compra estão marcadas por um <span>aumento significativo no interesse dos<br/> consumidores por ofertas mais atraentes e exclusivas,</span> com um foco crescente na conveniência e no<br/> atendimento de qualidade.
                </MainText>	
            </ContentContainer>
        </StyledView>
        </> 
    );
};

const StyledArrowSeparator = styled.img`
    position: absolute;
    bottom: -41px;
    width: 150px;
    @media screen and (max-width: ${MobileWidth}){
        bottom: -29px;
        width: 110px;
    }
`;

const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
`;

const LogoContainer = styled.div`
    display: flex;
`;

const MainText = styled.div`
    font-family: Work Sans;
    font-size: 20px;
    font-weight: 400;
    color: ${pmWhite};
    margin-top: 82px;
    text-align: center;
    @media screen and (max-width:  ${MobileWidth}){
        font-size: 11px;
        max-width: 282px;
        text-align: center;
        margin-top: 20px;
    }
    span{
        font-weight: bold;
    }
`;

const MainTitleSpot = styled.div`
    font-family: Work Sans;
    font-size: 96px;
    font-weight: 700;
    color: ${pmWhite};
    @media screen and (max-width:  ${MobileWidth}){
        font-size: 48px;
        text-align: center;
    }
    @media screen and (max-width: 402px){
        font-size: 42px;
    }
`

const MainTitle = styled.div`
    font-family: Work Sans;
    font-size: 64px;
    font-weight: 300;
    color: ${pmWhite};
    @media screen and (max-width:  ${MobileWidth}){
        font-size: 32px;
    }
`

const StyledLogo = styled.img`
    width: 387px;
    height: 62px;
    margin-bottom: 92px;
    @media screen and (max-width:  ${MobileWidth}){
        width: 193.50px;
        height: 31px;
        margin-bottom: 20px;
    }
`;

const StyledView = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    background-image: url(${Background});
    background-size: cover;
    background-repeat: no-repeat;
    padding-top: 67px;
    height: calc(100vw* 0.53);
    max-height: 764px;
    background-position-y: bottom;
    border-bottom-left-radius: 25px;
    border-bottom-right-radius: 25px;
    position: relative;
    min-height: 722px;
    @media screen and (max-width:  ${MobileWidth}){
        height: 492px;
        background-position-x: center;
        min-height: 492px;
    }
`;

export default Header;